<template>
  <div class="table-pagination-container">
    <div style="margin-bottom: 10px; color: #FF6F24" v-if="notice">
      {{ notice }}
    </div>
    <div class="table-pagination-container-form">
      <el-form v-model="form" :inline="true">
        <template v-for="item in needQueryList">
          <el-form-item :prop="item.key">
            <template #label v-if="item.search && item.type != 'tab'">
              {{item.label}}
            </template>
            <!-- 输入框 -->
            <el-input
              clearable
              v-if="item.search && item.type == 'input'"
              v-model="form[item.key]"
              :placeholder="`请输入${item.label}`"
            />

            <!-- 下拉选择 -->
            <ex-select
              :multiple="item.multiple"
              v-if="item.search && item.type == 'select'"
              clearable
              v-model="form[item.key]"
              :options="item.options"
              :placeholder="`请选择${item.label}`"
              style="width: 150px"
            />

            <!-- 时间选择 -->
            <el-date-picker
              v-if="item.search && (item.type === 'date' || item.type === 'datetime')"
              v-model="form[item.key]"
              style="width: 340px"
              :value-format="item.type === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
              :type="`${item.type}range`"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="(value) => dateChange(value, item)"
            ></el-date-picker>
          </el-form-item>
        </template>
        <slot name="form"></slot>
        <el-form-item>
          <el-button icon="Search" type="primary" @click="fetchData">{{ needQueryList.length > 0 ? '查询' : '搜索' }}</el-button>
        </el-form-item>
        <el-form-item v-if="needQueryList.length > 0">
          <el-button icon="Refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <slot name="button"></slot>
    </div>
    <div style="margin-bottom: 20px; margin-top: 10px">
      <el-row :gutter="10" class="mb8">
        <el-col v-if="newBtn" :span="1.5">
          <el-button
            type="primary"
            plain
            icon="Plus"
            @click="handleAdd"
          >新增
          </el-button>
        </el-col>
        <el-col v-if="deleteBtn" :span="1.5">
          <el-button
            type="danger"
            plain
            icon="Delete"
            :disabled="selectRows.length === 0"
            @click="handleDelete"
          >批量删除
          </el-button>
        </el-col>
        <el-col v-if="exportBtn || allExport" :span="1.5">
          <el-button
            type="info"
            plain
            icon="Download"
            :disabled="exportBtn ? selectRows.length === 0 : false"
            @click="handleExport"
          >导出
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div v-for="item in needQueryList.filter((item) => item.type == 'tab')">
      <el-tabs v-if="item.search && item.type == 'tab'"
               v-model="form[item.key]"
               @tab-click="handleTabChange">
        <el-tab-pane
          v-for="(item1, index1) in item.options"
          :label="item1.label"
          :name="item1.value"
          :key="index1"></el-tab-pane>
      </el-tabs>
    </div>
    <el-table
      :cell-style="cellStyle"
      v-loading="listLoading"
      :data="list"
      :default-expand-all="defaultExpandAll"
      @selection-change="setSelectRows"
    >
      <slot></slot>
    </el-table>
    <el-pagination
      style="margin-top: 10px"
      background
      v-model:current-page="page.current"
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="page.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>

  </div>
</template>

<script>

import ExSelect from '../ExSelect/index.vue'

export default {
  name: 'ExTable',
  components: {
    ExSelect
  },
  props: {
    request: Function,
    init: Function,
    query: Object,
    newBtn: Function,
    deleteBtn: Function,
    exportBtn: Function,
    allExport: Function,
    newPermit: String,
    deletePermit: String,
    exportPermit: String,
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    loadAndRequest: {
      type: Boolean,
      default: true,
    },
    cellStyle: {
      type: Function,
      default: () => {
        return {}
      }
    },
    notice: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      listLoading: false,
      list: [],
      needQueryList: [],
      form: {},
      page: {
        current: 1,
        size: 10,
      },
      total: 0,
      selectRows: []
    }
  },
  mounted() {
    this.init && this.init();
    this.loadAndRequest && this.fetchData();
  },
  unmounted() {
    this.clear();
  },
  methods: {
    handleCurrentChange(page) {
      this.page.current = page;
      this.$emit("page-change", this.page);
      this.fetchData();
    },
    handleSizeChange(size) {
      this.page.size = size;
      this.$emit("page-change", this.page);
      this.fetchData();
    },
    setSelectRows(val) {
      this.selectRows = val;
      this.$emit("selection-change", val);
    },
    async fetchData() {
      this.listLoading = true;
      try {
        if (this.request) {
          this.parseMultipleSelect();
          let data = await this.request(Object.assign({}, this.query, this.form, this.page));
          this.resetMultipleSelect();
          this.total = data.total;
          this.list = data.records;
        }
      } finally {
        this.listLoading = false;
      }
    },
    onChildSearchChange(param) {
      let item = this.needQueryList.find(v => v.key === param.key);
      if (item) {
        Object.assign(item, param);
      } else {
        this.needQueryList.push(param);
      }

      if (param.type == 'tab') {
        let tab = param.options ? param.options.find(v => v.default) : ''
        if (tab) {
          this.$set(this.form, param.key, tab.value);
        }
      }
    },
    handleTabChange() {
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    resetQuery() {
      this.needQueryList.forEach(item => {
        if (item.type != 'tab') {
          this.$set(this.form, item.key, '');
        }
        if (item.type.indexOf('date') !== -1) {
          this.$set(this.form, item.startTimeKey, '');
          this.$set(this.form, item.endTimeKey, '');
        }
      });
      this.$emit("reset");
      this.fetchData();
    },
    handleAdd() {
      this.newBtn && this.newBtn();
    },
    handleDelete() {
      this.deleteBtn && this.deleteBtn(this.selectRows);
    },
    handleExport() {
      // this.export && this.export(this.selectRows);
      this.allExport && this.allExport(Object.assign({}, this.query, this.form, this.page));
    },
    dateChange(value, item) {
      if (value && value instanceof Array && value.length === 2) {
        this.$set(this.form, item.startTimeKey, value[0]);
        this.$set(this.form, item.endTimeKey, value[1]);
        delete this.form[item.key];
      }
    },
    parseMultipleSelect() {
      for (let item of this.needQueryList) {
        if (item.type === 'select' && item.multiple && Array.isArray(this.form[item.key])) {
          this.$set(this.form, item.key, this.form[item.key].join(','));
        }
      }
    },
    resetMultipleSelect() {
      for (let item of this.needQueryList) {
        if (item.type === 'select' && item.multiple && typeof this.form[item.key] === 'string' && this.form[item.key]) {
          this.$set(this.form, item.key, this.form[item.key].split(','));
        }
      }
    },
    clear() {
      this.needQueryList = [];
      this.list = [];
      this.form = {};
    },
    search() {
      this.fetchData();
    }
  },
  provide() {
    return {
      "table-pagination": this.onChildSearchChange
    }
  }
}
</script>

<style scoped>
.table-pagination-container {
  padding: 10px 0;
}
.table-pagination-container-form {
  margin: 0 auto 10px;
}
::v-deep .el-tabs__header {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ExTable/ex-table.vue